import type { PlayersApi } from "@/v2/api/metadata/players";
import type { BackofficeContext } from "@/v2/framework/context/types";
import type { TranslationsTab } from "@/v2/framework/dialog/types";
import { readApiData } from "@/v2/api/response";
import { formatTranslationsForUpdate } from "@/services/helpers";
import { buildPlayerTranslationFields } from "../../translation-fields";

export function createTranslationsTab(options: {
  ctx: BackofficeContext;
  playersApi: PlayersApi;
}): TranslationsTab {
  const { ctx, playersApi } = options;

  return {
    kind: "translations",
    id: "translations",
    label: "Translations",
    persistence: "isolated",
    parentSubmitWithUnsavedTranslations: "block",
    fields: buildPlayerTranslationFields,
    api: {
      get: async ({ values }) => {
        const player = values as { id: string | number };
        const translations = readApiData(await playersApi.getTranslations(player.id));
        const list = Array.isArray(translations) ? translations : [];

        const languages = ctx.read.languages();
        const translationsPerLanguage = (list as Array<{ languageId: string | number }>).reduce(
          (acc, translation) => {
            acc.set(String(translation.languageId), translation);
            return acc;
          },
          new Map(),
        );

        return {
          languages,
          translationsPerLanguage,
        };
      },
      save: async (model, saveCtx) => {
        const entityId = (saveCtx.values as { id: string | number }).id;
        await playersApi.update(entityId, {
          translations: formatTranslationsForUpdate(
            model as Parameters<typeof formatTranslationsForUpdate>[0],
          ),
        });
      },
    },
  };
}
